import { render, staticRenderFns } from "./_CommissionStatus.vue?vue&type=template&id=faacf6bc"
import script from "./_CommissionStatus.vue?vue&type=script&lang=js"
export * from "./_CommissionStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports